"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestFullAccountBodyToJSON = exports.RequestFullAccountBodyFromJSONTyped = exports.RequestFullAccountBodyFromJSON = void 0;
function RequestFullAccountBodyFromJSON(json) {
    return RequestFullAccountBodyFromJSONTyped(json, false);
}
exports.RequestFullAccountBodyFromJSON = RequestFullAccountBodyFromJSON;
function RequestFullAccountBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'requestMessage': json['requestMessage'],
    };
}
exports.RequestFullAccountBodyFromJSONTyped = RequestFullAccountBodyFromJSONTyped;
function RequestFullAccountBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'requestMessage': value.requestMessage,
    };
}
exports.RequestFullAccountBodyToJSON = RequestFullAccountBodyToJSON;
